import React, { useState, useEffect } from 'react';
import { css } from 'emotion';
import { set } from "dot-prop-immutable";
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import { Transfer as DesignTransfer } from '@whalecloud/fdx';
import FormItem from "@whalecloud/page-builder-core/components/Render/components/FormItem";
import { makeEventProps } from '@whalecloud/page-builder-core/utils/common';
import { fetchOptions } from '@utils/util';

const left = css({ textAlign: 'left' });
const Transfer = props => {
  const { element, nameSpace, updateElement, initialData } = props;
  const { componentSettings, formSettings, formItemSettings, settings, className = '' } = element.data;
  const { visible } = settings;
  const { label, key, dataList = [], titles=["Source", "Target"], remote = {}, showSearch,  selectedKeys = [], targetKeys = [], ...rest } = componentSettings;

  useEffect(() => {
    // 远程数据，需请求
    fetchOptions(remote).then(res => {
      // options = res;
      let newElement = set(element, 'data.componentSettings.dataList', res);
      // newElement = set(element, 'data.componentSettings.targetKeys', initialData[element.name]);
      updateElement({ element: newElement }, nameSpace);
    });
  }, []);

  const updateSelectedKeys = (keys) => {
    const newElement = set(element, 'data.componentSettings.selectedKeys', keys);
    updateElement({ element: newElement }, nameSpace);
  }

  const updateTargetKeys = (keys) => {
    // const newElement = set(element, 'data.componentSettings.targetKeys', keys);
    // updateElement({ element: newElement }, nameSpace);
  }
   
  const eventProps = makeEventProps(element.data.events, nameSpace);

  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle }) => (

        <div>
          <FormItem
            id={element.id}
            style={elementStyle}
            className={getAllClasses('webiny-pb-base-page-element-style', 'webiny-pb-page-element-select', left)}
            {...formSettings}
            valuePropName={'targetKeys'}
          >
            <DesignTransfer
              titles = {titles}
              showSearch = {showSearch}
              style={{ width: '100%', visibility: visible }}
              className={className}
              dataSource={dataList.map((v, index) => Object.assign(v, { key: v[key] || index }))}
              {...rest}
              // {...formItemSettings}
              render={item => item[label]}
              // targetKeys={targetKeys}
              selectedKeys={selectedKeys}
              // onChange={(nextTargetKeys) => {
              //   // updateTargetKeys(nextTargetKeys);
              // }}
              onSelectChange={(sourceSelectedKeys, targetSelectedKeys) => {
                updateSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
              }}
              {...eventProps}
            />
          </FormItem>
        </div>
      )}
    </ElementRoot>
  );
};

export default Transfer;
